import React, {Component} from 'react';
import {NavBar, Toast,PickerView,Picker,Modal,List} from 'antd-mobile';
import {shiftDetail,lockSeat,unlockSeat,changeDriver,getChangeDriver} from "../../../service/shiftService";
import SeatSelect from "../../../components/SeatSelModal";
import {connect} from "react-redux";
import "./style.less";
const black = require('../../../common/image/black.png');
var timestamp = new Date().getTime();
let driverId,carId,driverName,carNum
@connect(
    state => ({userInfo: state.userInfo}),
)

export default class ShiftDetails extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        this.state = {
          driverId:'',
          driverData:[],
          pickerValue:[],
          startCity:'',
          endCity:'',
          date:'',
          weekend:'',
          startTime:'',
          passStations:'',
          driverName:'',
          lineId:'',
          data: [],
          logisticsOrderCount:'',
          modal:false,
          classId:'',
          carId:'',
          buyFlag:'',
          peopleNum:'',//已购人数
          startStationId:'',
          integral:0,
          seatNum:'',
          startCurrentTimeMillis:'',
          timestamp:timestamp,
          showModal:false,
          refundFlag:true,
          endStationId:'',
          specialRefund:'',
        };

    }

    componentDidMount() {
      this.getClassDetail();
        setTimeout(() => {
          this.getDriverData();
        }, 2000);
        driverId = '';
        carId = '';
        carNum = '';
        driverName = '';
    }
    //锁定出行位置
    lockSeat = (id) =>{
      let params = {
        token:this.props.userInfo.token,
        "data":{
          "id":id,
          "source":"6",
        }
      }
      Toast.loading("正在加载",0);
      lockSeat(params)
        .then((res) => {
            if (res.data.code === '0000') {
              Toast.hide();
              Toast.info("锁定成功",2);
              this.getClassDetail();

            }
            else if (res.data.code === '1401') {
              document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
          console.log(error);
      });
    }
    //解锁出行位置
    unlockSeat = (id) =>{
      let params = {
        token:this.props.userInfo.token,
        "data":{
          "id":id
        }
      }
      Toast.loading("正在加载",0);
      unlockSeat(params)
        .then((res) => {
            if (res.data.code === '0000') {
              Toast.hide();
              Toast.info("解锁成功",2);
              this.getClassDetail();
            }
            else if (res.data.code === '1401') {
              document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
          console.log(error);
      });
    }
    
    //获取行程详情
    getClassDetail = () =>{
      let params = {
        token:this.props.userInfo.token,
        "data":{
          "id":this.props.match.params.id
        }
      }
      Toast.loading("正在加载",0);
      shiftDetail(params)
        .then((res) => {
            console.log(res)
            if (res.data.code === '0000') {
              Toast.hide();
              let data = res.data.data
              this.setState({
                data:data.seatList,
                startCity:data.startCity,
                endCity:data.endCity,
                date:data.date,
                weekend:data.weekend,
                startTime:data.startTime,
                passStations:data.passStations,
                driverName:data.driverName,
                carNum:data.carNum,
                lineId:data.lineId,
                classId:data.id,
                peopleNum:data.sold,
                buyFlag:data.buyFlag,
                startStationId:data.startStationId,
                endStationId:data.endStationId,
                integral:data.integral,
                startCurrentTimeMillis:data.startCurrentTimeMillis,
                seatNum:data.seatList.length + 1,
                specialRefund:data.specialRefund,
                logisticsOrderCount:data.logisticsOrderCount
              })
            }
            else if (res.data.code === '1401') {
              document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
          console.log(error);
      });
    };
    //获取司机数据
    getDriverData(){
      let params = {
          token: this.props.userInfo.token,
          "data":{
            source:"6",
            "businessType":"1",
            "dispatcherId": this.props.userInfo.userId,
            "seatNum":this.state.seatNum
        }
      };
      getChangeDriver(params)
          .then((res) => {
              if (res.data.code === '0000') {
                let driverData =[]
                let data = res.data.data;
                var index = 0;
                for(let i in data){
                    let temp = data[i];
                    if(temp.carList.length == 0){
                      continue;
                    }
                      driverData.push({
                        label:temp.name,
                        value:temp.name,
                        id:temp.id,
                      
                      })
                      let listData =[];
                      for (let k in temp.carList){
                        let list = temp.carList[k];
                        listData.push({
                          label:list.carNum,
                          value:list.carNum,
                          id:list.id
                        })
                        driverData[index].children = listData;
                      }
                      index++;
                  }
               this.setState({
                 driverData:driverData
               })
              }
              else if (res.data.code === '1401') {
                document.location = `js://toLogin?token=${this.props.userInfo.token}`;
              }
              else {
                  Toast.info(res.data.msg);
              }
          }).catch(function (error) {
          console.log(error);
      });
    };
     //更换司机
     changeDriver =() =>{
        if(this.state.driverId == ''){
           driverId = this.state.driverData[0].id;
           driverName =  this.state.driverData[0].label;
          this.state.driverData.map(e=>{
            if(e.id == driverId){
              carId = e.children[0].id;
              carNum =  e.children[0].label;

            }
          })
        }
        this.state.data.forEach(d=>{
          if(d.status == 16 || d.status == 17 || d.status == 11){
            Toast.info('已有乘客在行程中或行程已结束，不可更换！')
            return
          }
        })
      let params = {
        token:this.props.userInfo.token,
       
        "data":{
            "id":this.state.classId,//行程id
            "driverId":this.state.driverId ? this.state.driverId : driverId,//司机id
            "carId": this.state.carId ? this.state.carId : carId,//车辆id
        }
      }
      // return
      Toast.loading("正在加载",0);
      changeDriver(params)
        .then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();

                this.setState({
                  driverName:this.state.pickerValue[0] ? this.state.pickerValue[0] : driverName,
                  carNum:this.state.pickerValue[1] ? this.state.pickerValue[1] : carNum
                })
                Toast.info("更改成功");
            }
            else if (res.data.code === '1401') {
              document.location = `js://toLogin?token=${this.props.userInfo.token}`;
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
          console.log(error);
      });
    }
    check(res){
      if( res.status == 2 || res.status == 3 || res.status == 5){
          return 'lock'//出行位置锁定 ，红色
      }else if(res.status == 1||res.status == 4){
          return 'unsold'//未售，可下单
      }else{
        return 'selected'
      }
  };
    status(res){
      if(res.status == 2 || res.status == 3 || res.status == 5){
          return <span style={{color:"#F66D53"}}>出行位置已被锁定</span>
      }else if(res.status == 1){//未售，无提示语言
          return <span>&nbsp;</span>
      }else if(res.status == 4){//正在支付中
        return <span style={{color:"#F66D53"}}>正在支付中，不可操作！</span>
      }
      else if(res.status == 12 ||  res.status == 14 ){
          return <span style={{color:"#16BC84"}}>待出发，待出发报单</span>
      }
      else if(res.status == 13){
          return <span style={{color:"#F8A216"}}>待出发，待到达报单</span>
      }
      else if(res.status == 16){
        return <span style={{color:"#F8A216"}}>行程中，待到达报单</span>
      }
      else if(res.status == 15){
        return <span style={{color:"#3679FE"}}>待出发，分流已报单</span>
      } 
      else if(res.status == 17){
        return <span style={{color:"#3679FE"}}>行程中，分流已报单</span>
      }
      else if(res.status == 11){
          return <span style={{color:"#A4A5A9"}}>服务已完成</span>
      }
    };
  
    
    goPage(v,k,j,i){
      if(v == "addPassengers"){
        this.props.history.push(
          '/addPassengers',
          {
            lineId:this.state.lineId,
            classId:this.state.classId,
            startStationId:this.state.startStationId,
            endStationId:this.state.endStationId,
            startCity:this.state.startCity,
            endCity:this.state.endCity,
            seatId:j,
            integral:this.state.integral
          }
        )
      }
      if(v == "passengerInfo"){
        this.props.history.push('/passengerInfo',
          {
            lineId:this.state.lineId,
            classId:this.state.classId,
            startStationId:this.state.startStationId,
            startCity:this.state.startCity,
            endCity:this.state.endCity,
            seatId:j,
            timestamp:this.state.timestamp,
            startCurrentTimeMillis:this.state.startCurrentTimeMillis,
            owner:k.owner,
            status:k.status,
          }
        )
      }
      if(v == 'SelectShift'){
        if(this.state.timestamp  > this.state.startCurrentTimeMillis){
          this.setState({
              showModal:true,
              refundFlag:false
          })
          return
        }
        this.props.history.push('/SelectShift',
        {
            startCity:k.startCity,
            endCity:k.endCity,
            startPosition:k.startPosition,
            endPosition:k.endPosition,
            id:k.orderId,//需要订单id
            startAddress:k.startAddress,
            endAddress:k.endAddress,
            "lineIds": [
              {
                  "endStationId":k.endStationId,
                  "lineId":k.lineId,
                  "startStationId":k.startStationId
              }
            ],
            type:i,
            classId:this.state.classId,
            totalPrice:k.totalPrice

        })
    }
    //退款
    if(v == 'refundTicket'){
      if(this.state.timestamp  > this.state.startCurrentTimeMillis){
        this.setState({
            showModal:true,
            refundFlag:true
        })
        return
      }
        this.props.history.push('/refundTicket',{id:k.orderId})
    }

    }
    onchange =(v)=>{
      this.setState({ pickerValue: v })
      let drivers = this.state.driverData;
      drivers.forEach(d => {
        if(d.label == v[0] || d.value == v[0]){
          var cars = d.children;
          this.setState({
              driverId:d.id
            });
          if(cars){
            cars.forEach(car=>{
              if(car.label == v[1] || car.value ==v[1]){
                this.setState({
                  carId:car.id
                });
              }
            });
          }
        }        
      });
      
    }
    onClose(index){
      this.setState({
         refundShow:false
      });
  }
  modalShow =()=>{
    var flag = 0 ;
    this.state.data.map(e=>{
      if(e.status == 16 || e.status == 17 || e.status == 11){
        Toast.info('已有乘客在行程中，不可更换！');
        flag = 1;
        
      } 
    })
    if(flag == 0 ){
      this.setState({modal:!this.state.modal})
    }
  }
    render() {
    const {startCurrentTimeMillis,buyFlag,data,timestamp,specialRefund} = this.state;
        return (
            <div className="shiftDetails">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >行程详情</NavBar>
                <div className="cardBox">
                    <div className="body">
                        <div>{this.state.startCity}</div>
                        <div className="imgContent">
                          <div>
                            {this.state.date} {this.state.weekend} {this.state.startTime}
                          </div>
                          <img src={black}/>
                        </div>
                        <div>{this.state.endCity}</div>
                    </div>
                    <div className="footer">
                        <div>{this.state.driverName}  <span>{this.state.carNum}</span></div>
                       {/*  {this.state.peopleNum == 0 ? <div onClick={() => this.modalShow()}>更换司机</div> : <div style={{background:'white'}}></div>} */}
                        <div onClick={() => this.modalShow()}>更换司机</div>
                    </div>
                    <div className="site">途经起止点：{this.state.passStations == ''? <span>无途经起止点</span>:<span>{this.state.passStations}</span>}</div>
                    <SeatSelect 
                      seatData = {data}
                      goPage = {this.goPage.bind(this)}
                      status = {this.status.bind(this)}
                      check = {this.check.bind(this)}
                      unlockSeat = {this.unlockSeat.bind(this)}
                      lockSeat = {this.lockSeat.bind(this)}
                      startCurrentTimeMillis = {startCurrentTimeMillis}
                      specialRefund={specialRefund}
                      buyFlag = {buyFlag}
                      timestamp = {timestamp}
                      />
                      <div className='content'>
                        <div className="bottomBtn" onClick={()=>this.props.history.push('/passengerList',{id:this.props.match.params.id})}>乘客明细</div>
                        <div className="bottomBtn blue" onClick={()=>this.props.history.push('/bringGoodList',{id:this.state.classId})}>带货（{this.state.logisticsOrderCount}件）</div>
                      </div>
                  </div>
                <Modal
                    popup
                    visible={this.state.modal}
                    animationType="slide-up"
                >
                  <div className="modalSelect">
                        <span onClick={() => this.setState({modal: false})}>取消</span>
                        <span>选择司机</span>
                        <span onClick={() => {this.setState({modal: false});this.changeDriver()}}>完成</span>
                  </div> 
                  <PickerView
                    title="请选择司机"
                    cols={2}
                    data={this.state.driverData}
                    value={this.state.pickerValue}
                    onChange={(v)=> this.onchange(v)}
                  />
                  
                </Modal>
                <Modal
                    className="billViewModal"
                    visible={this.state.showModal}
                    transparent
                    maskClosable={true}
                    footer={[{ text: '知道了', onPress: () => { this.setState({showModal:!this.state.showModal}); } }]}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                >
                  <div className='refundModal'>
                    <div className="wordtip">{this.state.refundFlag ?'退票失败':'改签失败'}</div>
                    <div className="waitTip">{this.state.refundFlag ?'分流司机已经出发，请联系客服协商退款。':'行程已经出发，改签失败，请联系客服' }</div>
                  </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Shift/ShiftDetails/index.js